export const dummyFeeProfile = {
    studentId: "uoi959kBkoz6qzvBYDCU",
    templateId: "TMP001",
    monthlyHeads: [
        {
            month: "2025-04",
            heads: [
                { headId: "TUTION", headName: "Tuition Fee", amount: 1000 },
                { headId: "DEVFEE", headName: "Development Fee", amount: 300 },
            ],
        },
        {
            month: "2025-05",
            heads: [
                { headId: "TUTION", headName: "Tuition Fee", amount: 1000 },
                { headId: "DEVFEE", headName: "Development Fee", amount: 300 },
            ],
        },
        {
            month: "2025-06",
            heads: [
                { headId: "TUTION", headName: "Tuition Fee", amount: 1000 },
                { headId: "DEVFEE", headName: "Development Fee", amount: 300 },
            ],
        },
        {
            month: "2025-07",
            heads: [
                { headId: "TUTION", headName: "Tuition Fee", amount: 1000 },
                { headId: "DEVFEE", headName: "Development Fee", amount: 300 },
            ],
        },
    ],
    concessions: [],
};